import React from "react";
import styles from "./trust-hero.module.css";
import LogoMarquee from "../logo-marquee/logo-marquee";
import QuoteCarousel from "../../quote-carousel";
import heroQuotes from "../../quote-carousel/quotes.json";

// Marquee logos removed from here - moved to logo-marquee component


export default function TrustHero() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Left Column: 60% */}
        <div className={styles.leftColumn}>
          <div className={styles.eyebrow}>
            <span className={`${styles.phrase} ${styles.phrase1}`}>132 Female Experts.</span>
            <span className={`${styles.phrase} ${styles.phrase2}`}>3 Years of Reporting.</span>
            <span className={`${styles.phrase} ${styles.phrase3}`}>Science-Backed.</span>
            <span className={`${styles.phrase} ${styles.phrase4}`}>The New Standard in Women's Health.</span>
          </div>

          <h1 className={styles.headline}>
            The New Rules of <br />
            <span className={styles.highlight}>Women's Health</span>
          </h1>

          <p className={styles.description}>
            A rigorously fact-checked lifespan roadmap by award-winning journalist Meghan Rabbitt. Commissioned by Maria Shriver to fill the gaps in women’s medical research.
          </p>

          <div className={styles.ctaGroup}>
            <button className={styles.btnPrimary}>
              Order the Book
            </button>
            <button className={styles.btnSecondary}>
              Meet the Experts
            </button>
            <button className={styles.btnSecondary}>
              Explore the Book
            </button>
          </div>
        </div>

        {/* Right Column: 40% */}
        <div className={styles.rightColumn}>
          <img
            src="/assets/images/book-3d.png"
            alt="The New Rules of Women's Health Book"
            className={styles.bookImage}
          />
        </div>
      </div>

      {/* <QuoteCarousel quotes={heroQuotes} /> */}

      <div className={styles.logoContainer}>
        <h3 className={styles.logoTitle}>You've seen Meghan's work in</h3>
        <LogoMarquee variant="stacked" />
      </div>

    </section>
  );
}
